// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"689":"96601298","958":"374b6f9e"}[chunkId] + ".css";
};